import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { buyers, IMAGES } from '../data/content';
const MINUTES = [2, 4, 6, 7, 9, 11, 13, 16];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: number;
    let nextTimer: number;
    const show = () => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        nextTimer = window.setTimeout(() => {
          setIndex(prev => (prev + 1) % buyers.length);
          show();
        }, 9000);
      }, 6000);
    };
    const startTimer = window.setTimeout(show, 6000);
    return () => {
      window.clearTimeout(startTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, []);
  const buyer = buyers[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-211" data-mp="165h9cn1m3t2t">
      {visible && <motion.aside key={buyer.name} initial={{
      opacity: 0,
      x: -24
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -24
    }} transition={{
      duration: 0.3
    }} aria-live="polite" className="fixed bottom-24 left-3 z-40 flex w-[min(320px,calc(100vw-24px))] items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 shadow-xl" data-id="element-212" data-mp="164ekeknuo0pj">
          <img src={IMAGES.mockup} alt="" aria-hidden="true" className="h-12 w-12 shrink-0 rounded-lg bg-cream object-contain" data-id="element-213" data-mp="n97o9fsam29b" />
          <div className="min-w-0" data-id="element-214" data-mp="x6m2d8qqueyg">
            <p className="flex items-center gap-1 text-[11px] font-semibold text-emerald-600" data-id="element-215" data-mp="s6hkpfe3ne6n">
              <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-216" data-mp="28kg2uhd2vdt2" /> Compra confirmada
            </p>
            <p className="truncate text-[13px] font-bold text-navy" data-id="element-217" data-mp="23lmybefrqx51">{buyer.name}</p>
            <p className="truncate text-[11px] leading-snug text-navy/60" data-id="element-218" data-mp="2aol7qmdxes7h">
              {buyer.city} · adquirió la Ruta Clínica
            </p>
            <p className="text-[10px] text-navy/40" data-id="element-219" data-mp="2fmmlcrsl1zbk">hace {minutes} minutos</p>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}